import { FC } from 'react';
import './cards-order-tabs.scss';

type TabsWrapProps = {
  children: React.ReactNode;
};

type TabProps = {
  title: string;
  type: 'left' | 'right';
  onClick: () => void;
  active: boolean;
};

export const CardsOrderTabsWrap: FC<TabsWrapProps> = ({ children }) => {
  return <div className="cards-order-tabs-wrap">{children}</div>;
};

export const CardsOrderTab: FC<TabProps> = ({ title, type, active, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`cards-order-tab ${active ? 'cards-order-tab--active' : ''} cards-order-tab--${type}`}
    >
      <span>{title}</span>
    </button>
  );
};
